import React, { Component } from 'react';
import TopNav from '../components/top_nav';
import Footer from '../components/footer';
import { toast } from 'react-toastify';
import { ArrowRight } from 'react-bootstrap-icons';
import positions from '../databases/careers_db'




export default class CareerScreen extends Component {
    render() {
        return (
            <div>
                <TopNav />
                <div className="container p-4 p-md-5">
                    <div className="mb-5">
                        <h2 className="fs-36">Build the Future of Rail. With Us.</h2>
                        <h3 className="fw-semibold mt-3 fs-52" style={{ fontSize: "2.5rem" }}>
                            Why Work with <span className="fw-bold">BHEPL?</span>
                        </h3>
                    </div>

                    <div className="">
                        <p className="mb-4">
                            At <strong>BHEPL</strong>, we are more than just technology providers
                        </p>

                        <p className="mb-4">
                            We are <strong>railway technocrats, problem-solvers, and visionaries.</strong>
                        </p>

                        <p className="mb-4">
                            With over <strong>four decades</strong> of collective expertise, we’ve been at the forefront of <strong>designing, deploying, and modernizing advanced rail systems</strong> across India and beyond. Every project we undertake reflects
                        </p>

                        <p className="mb-4">
                            our deep-rooted domain knowledge and industry-first mindset.
                        </p>

                        <p>
                            We work where <strong>technology meets real-world complexity</strong>, and we thrive on it. From high-precision system integrations to large-scale R&D-led innovations, we tackle the evolving challenges of modern rail networks with one goal:
                            <strong> to create safer, smarter, and more efficient railways.</strong>
                        </p>
                    </div>

                    <div className="row justify-content-center align-items-center mt-5 mx-0 g-0">
                        <div className='col-12 col-md-9 ps-md-0 pe-md-3'>
                            <div className="w-100 h-80-40">
                                <img
                                    src="/career1.webp"
                                    alt="Careers"
                                    className="img-fluid w-100 h-100 rounded-4"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                        </div>
                        <div className='col-12 col-md-3 mt-md-0 mt-3'>
                            <div className="w-100 h-80-40">
                                <img
                                    src="/career2.avif"
                                    alt="Careers"
                                    className="img-fluid w-100 h-100 rounded-4"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className="row justify-content-center align-items-center mt-3 mx-0 g-0">
                        <div className='col-12 col-md-3 ps-md-0'>
                            <div className="w-100 h-80-40">
                                <img
                                    src="/career3.webp"
                                    alt="Careers"
                                    className="img-fluid w-100 h-100 rounded-4"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                        </div>
                        <div className='col-12 col-md-9 mt-md-0 mt-3 ps-md-3'>
                            <div className="w-100 h-80-40">
                                <img
                                    src="/career4.webp"
                                    alt="Careers"
                                    className="img-fluid w-100 h-100 rounded-4"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                        <img src="/career3.webp"
                            alt="Careers"
                            className="img-fluid rounded-4"
                            style={{ objectFit: "cover", maxHeight: "80vh" }} />
                        <img src="/career4.webp"
                            alt="Careers"
                            className="img-fluid w-100 rounded-4"
                            style={{ objectFit: "cover", maxHeight: "80vh" }} />
                    </div> */}

                    <div className="container py-5">
                        <div className="text-center mb-4">
                            <h6 className="text-muted">Current Openings</h6>
                            <h2 className="fw-bold fs-36">Explore Open Positions</h2>
                        </div>

                        <div className="row mt-5 bg-grey-color">
                            {positions.map((job, index) => (
                                <div className="col-md-4 mb-4" key={index}>
                                    <div className="  rounded-4 p-4 h-100 d-flex flex-column justify-content-between">
                                        <div>
                                            <div className="mb-3">
                                                <span className="badge   text-dark border me-2 px-3 py-1 rounded-pill fs-14">
                                                    {job.type}
                                                </span>
                                                <span className="badge   text-dark border px-3 py-1 rounded-pill fs-14">
                                                    {job.location}
                                                </span>
                                            </div>
                                            <h5 className="fs-18 fw-bold">{job.title}</h5>
                                        </div>
                                        <div>
                                            <p className="fs-14">{job.description}</p>
                                        </div>
                                        <div>
                                            <button
                                                onClick={() => window.location.href = `job-description/${job.id}`}
                                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-3 bg-primary-blue"
                                            >
                                                <span className="mx-3 fs-14">View full job description</span>
                                                <div
                                                    className="d-flex justify-content-center align-items-center rounded-circle"
                                                    style={{
                                                        width: '35px',
                                                        height: '35px',
                                                        backgroundColor: '#ffffff',
                                                    }}
                                                >
                                                    <ArrowRight color="#193E6C" />
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="mb-5">
                        <div className="bg-grey-color rounded-4 p-4">
                            <h6 className="text-primary-blue fw-semibold mb-2 fs-20">
                                Can’t Find a Role That Fits?
                            </h6>
                            <h2 className="fw-bold mb-3">We’d still love to hear from you.</h2>
                            <p className="mb-4 fs-18">
                                We’re always open to meeting great minds. If you’re passionate about
                                what we do and believe you can bring value to the future of rail
                                technology, don’t wait for a listing.
                            </p>
                            <button
                                onClick={() => window.location.href = "contact"}
                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-3 bg-primary-blue"
                            >
                                <span className="mx-3 fs-14">Apply now</span>
                                <div
                                    className="d-flex justify-content-center align-items-center rounded-circle"
                                    style={{
                                        width: '35px',
                                        height: '35px',
                                        backgroundColor: '#ffffff',
                                    }}
                                >
                                    <ArrowRight color="#193E6C" />
                                </div>
                            </button>
                        </div>
                    </div>


                </div>
                <Footer />


            </div>
        );
    }
}